export default __webpack_public_path__ + "static/media/elephant.c7c14c9c.jpg";